var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15761 8.13783C15.7483 0.557864 28.0876 0.63846 35.7246 8.27555C43.365 15.9159 43.4424 28.2626 35.8526 35.8524C28.2627 43.4422 15.9161 43.3649 8.27572 35.7245C3.74802 31.1968 1.87832 25.0198 2.68119 19.1625C2.79368 18.3417 3.55024 17.7675 4.37099 17.88C5.19174 17.9925 5.76589 18.7491 5.65339 19.5699C4.97345 24.5305 6.55589 29.762 10.397 33.6032C16.886 40.0921 27.333 40.1293 33.7312 33.7311C40.1294 27.3329 40.0923 16.8858 33.6033 10.3969C27.1177 3.91123 16.678 3.87078 10.2789 10.2591L11.7743 10.2667C12.6028 10.2708 13.2709 10.9458 13.2668 11.7742C13.2626 12.6026 12.5877 13.2708 11.7593 13.2666L6.66816 13.241C5.84563 13.2369 5.17985 12.5711 5.17572 11.7486L5.15014 6.65749C5.14597 5.82907 5.81416 5.15413 6.64258 5.14997C7.471 5.14581 8.14594 5.81399 8.1501 6.64241L8.15761 8.13783ZM22 12.4998C22.8284 12.4998 23.5 13.1714 23.5 13.9998V21.3785L28.0607 25.9392C28.6465 26.525 28.6465 27.4747 28.0607 28.0605C27.4749 28.6463 26.5251 28.6463 25.9393 28.0605L20.5 22.6212V13.9998C20.5 13.1714 21.1716 12.4998 22 12.4998Z",
    fill: "#009BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailability);
export default __webpack_public_path__ + "static/media/availability.9c19a9e49ffa1bc6c36a643b00e9c84d.svg";
export { ForwardRef as ReactComponent };